import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "border-t border-gray-200 bg-gray-50" }
const _hoisted_2 = { class: "mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8" }
const _hoisted_3 = { class: "grid gap-10 md:grid-cols-3" }
const _hoisted_4 = { class: "mt-4 space-y-2" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "mt-10 flex flex-col items-center justify-between gap-4 border-t border-gray-200 pt-8 sm:flex-row" }
const _hoisted_7 = { class: "text-sm text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createVNode(_component_Logo, {
            class: "h-9",
            "with-text": true
          }),
          _cache[0] || (_cache[0] = _createElementVNode("p", { class: "mt-4 max-w-xs text-sm leading-6 text-gray-600" }, " Profesionálny vývoj softvéru a hardvéru, integrácia systémov a IT konzultácie. ", -1))
        ]),
        _createElementVNode("div", null, [
          _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "text-sm font-semibold uppercase tracking-wider text-gray-900" }, " Navigácia ", -1)),
          _createElementVNode("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navLinks, (link) => {
              return (_openBlock(), _createElementBlock("li", {
                key: link.href
              }, [
                _createElementVNode("a", {
                  href: link.href,
                  class: "text-sm text-gray-600 transition hover:text-brand-600"
                }, _toDisplayString(link.label), 9, _hoisted_5)
              ]))
            }), 128))
          ])
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", null, [
          _createElementVNode("h3", { class: "text-sm font-semibold uppercase tracking-wider text-gray-900" }, " Kontakt "),
          _createElementVNode("ul", { class: "mt-4 space-y-2 text-sm text-gray-600" }, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: "mailto:firma@himalia.sk",
                class: "hover:text-brand-600"
              }, " firma@himalia.sk ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: "tel:0432225122",
                class: "hover:text-brand-600"
              }, " 043 2225122 ")
            ]),
            _createElementVNode("li", null, "Dolný Kubín, Slovensko")
          ])
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", _hoisted_7, " © " + _toDisplayString(_ctx.year) + " Himalia s.r.o. Všetky práva vyhradené. ", 1),
        _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-sm text-gray-500" }, "IČO: 53462980", -1))
      ])
    ])
  ]))
}